import { createApp } from 'vue'
import App from './EnvironmentOcean.vue'

createApp(App).mount('#app-environment-ocean')
